import { FsLogLevel, logToFullStory } from '@igs-web/common-utilities/utilities/fs-logger'

window.addEventListener('error', (event: ErrorEvent) => {
    const message = `${event.filename} ${event.lineno}:${event.colno} - ${event.message} \n\r ${event.error}`
    logToFullStory(FsLogLevel.error, message)
})
